import Vue from 'vue';
import fb from '../../firebaseConfig.js';
import { TAGS, TAGS_PAGINATION, SET_TAGS_PAGINATION, SET_TAGS, CURRENT_USER } from '../constants';

export default {
  namespaced: true,
  state: {
    [TAGS]: [],
    [TAGS_PAGINATION]: {
      page: 1,
      limit: 10,
      total: 0
    }
  },
  actions: {
    async fetchTags({ commit, rootState }, payload) {
      try {
        let response = await fb.users
          .doc(rootState.auth[CURRENT_USER].uid)
          .collection('tags')
          // .offset(payload.page * payload.limit)
          .limit(payload.limit)
          .get();
        commit(
          SET_TAGS,
          response.docs.map(d => d.data())
        );
        commit(SET_TAGS_PAGINATION, {
          // page: data.page,
          // limit: data.limit,
          // total: data.total
        });
        return response;
      } catch (error) {
        Vue.prototype.$notification.error({
          message: 'Ooops! Something went wrong while fetching tags.',
          description: error.message,
          placement: 'bottomLeft'
        });
        throw error;
      }
    },
    async saveTag({ commit, state, rootState, dispatch }, { name, id }) {
      try {
        const uid = rootState.auth[CURRENT_USER].uid;
        const batch = fb.db.batch();
        batch.update(fb.users.doc(uid), {
          'hasConfigured.tags': true
        });
        const tmpTags = state[TAGS];
        let docRef, tmp;
        if (id) {
          docRef = fb.users.doc(id.replace('users/', ''));
          tmp = {
            id: id,
            name: name
          };
          tmpTags.forEach(d => {
            if (d.id === id) {
              d.name = name;
            }
          });
        } else {
          docRef = fb.users
            .doc(uid)
            .collection('tags')
            .doc();

          tmp = {
            id: docRef.path,
            name: name
          };
          tmpTags.push(tmp);
        }
        batch.set(docRef, tmp);

        await batch.commit();
        dispatch('auth/fetchUserProfile', null, { root: true });
        commit(SET_TAGS, tmpTags);
        return batch;
      } catch (error) {
        Vue.prototype.$notification.error({
          message: 'Ooops! Something went wrong while saving tags.',
          description: error.message,
          placement: 'bottomLeft'
        });
        throw error;
      }
    },
    async deleteTag({ commit, state, dispatch }, id) {
      try {
        const batch = fb.db.batch();
        batch.delete(fb.users.doc(id.replace('users/', '')));
        await batch.commit();
        dispatch('auth/fetchUserProfile', null, { root: true });
        commit(
          SET_TAGS,
          state[TAGS].filter(d => d.id !== id)
        );
        return batch;
      } catch (error) {
        Vue.prototype.$notification.error({
          message: 'Ooops! Something went wrong while deleting tags.',
          description: error.message,
          placement: 'bottomLeft'
        });
        throw error;
      }
    },
    async validateTag({ rootState }, name) {
      try {
        let response = await fb.users
          .doc(rootState.auth[CURRENT_USER].uid)
          .collection('tags')
          .where('name', '==', name)
          .get();
        return response.size;
      } catch (error) {
        Vue.prototype.$notification.error({
          message: 'Ooops! Something went wrong while fetching tags.',
          description: error.message,
          placement: 'bottomLeft'
        });
        throw error;
      }
    }
  },
  mutations: {
    [SET_TAGS_PAGINATION]: (state, pagination) => {
      state[TAGS_PAGINATION] = pagination;
    },
    [SET_TAGS]: (state, data) => {
      state[TAGS] = data;
    }
  }
};
